<div class="left-slot">
  <ng-content select="[left]"></ng-content>
</div>

@if (!shutterHidden) {
  <button class="shutter-button" [disabled]="shutterDisabled" (click)="onShutterClick()">
    <div class="shutter-inner"></div>
  </button>
}

<div class="right-slot">
  <ng-content select="[right]"></ng-content>
</div>
